module.exports = __webpack_public_path__ + "static/media/bg-image-2.f8da21b5.jpg";